import React from 'react';

const Viator = () => {
    return (

        <div className="container">
            <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3">
                    Things to Do In Mexico:
                </h6>
                <h1 className="mb-5">Cancun Month</h1>
            </div>
            <div
                data-vi-partner-id="P00284098"
                data-vi-widget-ref="W-8fec5d0e-d71a-4bb7-ab35-d7decdda4319"
                data-vi-search-term="Cancun"
            ></div>
        </div>
    );
};

export default Viator;
